export default "__VITE_ASSET__691f0c0f__"